import { useEffect, useState } from "react";
import { Github } from "../../services/github/service";
import { Link } from "react-router-dom";
import UserListItem from "../../components/users/userListItem";
import style from "./index.module.scss"


const Users = () => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);


    const getSkeletons = () => {
        let skeletons = [];
        for (let i = 0; i < 10; i++) {
            skeletons.push(<UserListItem loading={true} key={i} />)
        }
        return skeletons;
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const response = await Github.getUsers();
            setUsers(response);
            console.log(response);
            setLoading(false);
        }
        fetchData();
    }, []);
    return (
        <div className={style.listing}>
            {loading && <div className={style.userListing}>
                {getSkeletons()}</div>}

            <div className={style.userListing}>
                {users.map((user) => {
                    return (
                        <Link to={`/users/${user.login}`} key={user.id}>
                            <UserListItem user={user} />
                        </Link>
                    )
                })}
            </div>


        </div>
    );
}

export default Users;